import React from "react";

interface ExclamationIconProps {
  className?: string;
  onClick?: () => void;
}

export const ExclamationIcon = ({
  className,
  onClick,
}: ExclamationIconProps) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M8 2.34375C6.35938 2.34375 4.96484 2.92708 3.81641 4.09375C2.66797 5.24219 2.09375 6.6276 2.09375 8.25C2.09375 9.89062 2.66797 11.2852 3.81641 12.4336C4.98307 13.582 6.3776 14.1562 8 14.1562C9.64062 14.1562 11.0352 13.582 12.1836 12.4336C13.332 11.2669 13.9062 9.8724 13.9062 8.25C13.9062 6.60938 13.3229 5.21484 12.1562 4.06641C11.0078 2.91797 9.6224 2.34375 8 2.34375ZM3.1875 3.46484C4.51823 2.13411 6.1224 1.46875 8 1.46875C9.8776 1.46875 11.4727 2.13411 12.7852 3.46484C14.1159 4.77734 14.7812 6.3724 14.7812 8.25C14.7812 10.1276 14.1159 11.7318 12.7852 13.0625C11.4727 14.375 9.8776 15.0312 8 15.0312C6.1224 15.0312 4.51823 14.375 3.1875 13.0625C1.875 11.7318 1.21875 10.1276 1.21875 8.25C1.21875 6.3724 1.875 4.77734 3.1875 3.46484ZM7.69922 4.75H8.30078C8.41016 4.75 8.49219 4.78646 8.54688 4.85938C8.61979 4.91406 8.64714 4.98698 8.62891 5.07812L8.4375 9.67188C8.4375 9.89062 8.32812 10 8.10938 10H7.89062C7.67188 10 7.5625 9.89062 7.5625 9.67188L7.37109 5.07812C7.35286 4.98698 7.37109 4.91406 7.42578 4.85938C7.4987 4.78646 7.58984 4.75 7.69922 4.75ZM7.45312 10.7656C7.59896 10.6198 7.78125 10.5469 8 10.5469C8.21875 10.5469 8.40104 10.6198 8.54688 10.7656C8.69271 10.9115 8.76562 11.0938 8.76562 11.3125C8.76562 11.5312 8.69271 11.7135 8.54688 11.8594C8.40104 12.0052 8.21875 12.0781 8 12.0781C7.78125 12.0781 7.59896 12.0052 7.45312 11.8594C7.30729 11.7135 7.23438 11.5312 7.23438 11.3125C7.23438 11.0938 7.30729 10.9115 7.45312 10.7656Z"
      fill="#45547C"
    />
  </svg>
);

ExclamationIcon.defaultProps = {
  className: "",
  onClick: undefined,
};
